import { preferredEnv, twoFactorEnabled } from './config'
import { clearSession, readSession, saveSession } from './session'
import { remoteRequest } from './httpClient'
import { cleanSabreToken } from './tokens'

let pendingLogin = null
let otplibAuthenticator = null

function normalizeDashboardPermissions(value) {
  const permissions = value && typeof value === 'object' ? value : {}
  return {
    scriptGenerator: permissions.scriptGenerator === true,
    repositories: permissions.repositories === true,
  }
}

async function getAuthenticator() {
  if (!otplibAuthenticator) {
    const module = await import('@otplib/preset-browser')
    otplibAuthenticator = module.authenticator
  }
  return otplibAuthenticator
}

export async function login(body) {
  const data = await remoteRequest('POST', '/login', {
    jwt: false,
    bootstrap: true,
    body: { email: body.email, password: body.password },
  })
  const authorization = data?.token || data?.access_token
  const secret = data?.token2 || data?.secret2 || data?.secret
  if (!authorization || !secret) throw new Error('Respuesta de login incompleta')
  pendingLogin = {
    authorization,
    secret,
    email: body.email,
    expiresIn: Number(data.expires_in || 3600),
    dashboardPermissions: normalizeDashboardPermissions(data?.dashboardPermissions),
  }

  if (!twoFactorEnabled()) {
    saveSession({
      env: preferredEnv(),
      jwt: pendingLogin.authorization,
      jwtExp: Date.now() + Math.max(60, pendingLogin.expiresIn) * 1000,
      email: pendingLogin.email,
      dashboardPermissions: pendingLogin.dashboardPermissions,
    })
    pendingLogin = null
    return { ok: true, requires_2fa: false, email: body.email, expires_in: Number(data.expires_in || 3600) }
  }

  return { ok: true, requires_2fa: true, email: body.email, expires_in: pendingLogin.expiresIn }
}

export async function verifyLogin(body) {
  const code = String(body.code || '').replace(/\D/g, '')
  if (!pendingLogin || !/^\d{6}$/.test(code)) throw new Error('Codigo de doble factor invalido')
  const authenticator = await getAuthenticator()
  const isValid = authenticator.check(code, pendingLogin.secret)
  if (!isValid) throw new Error('Codigo de doble factor invalido o expirado')
  saveSession({
    env: preferredEnv(),
    jwt: pendingLogin.authorization,
    jwtExp: Date.now() + Math.max(60, pendingLogin.expiresIn) * 1000,
    email: pendingLogin.email,
    dashboardPermissions: pendingLogin.dashboardPermissions,
  })
  pendingLogin = null
  return { ok: true, email: readSession().email }
}

export function setSabreToken(body) {
  saveSession({ env: preferredEnv(), sabreToken: cleanSabreToken(body.token) })
  return { ok: true }
}

export async function currentUser() {
  const data = await remoteRequest('GET', '/currentUser')
  if (data?.dashboardPermissions) {
    saveSession({ dashboardPermissions: normalizeDashboardPermissions(data.dashboardPermissions) })
  }
  return data
}

export async function updateDashboardPermissions(body) {
  return remoteRequest('PATCH', '/users/dashboard-permissions', {
    body: {
      userId: Number(body.userId || 0),
      enableScriptGenerator: body.enableScriptGenerator === true,
      enableRepositories: body.enableRepositories === true,
    },
  })
}

export function logout() {
  clearSession()
  pendingLogin = null
  return { ok: true }
}
